export const DEPRECIATION = {
  initial_used_factor: 0.92,
  age: {
    phase1_years: 17,
    phase1_power: 1.2,
    transition_value_eur: 500,
    phase2_end_years: 25,
    phase2_power: 2.0,
    floor_value_eur: 150,
  },
  rides: {
    first_ride_penalty: 0.05,
    per_ride_pct: 0.03,
    floor: 0.10,
  },
};

export const ADJUSTMENTS = {
  brand_attractiveness: {
    'performance-designs': {
      'optimum': 1.05,
      'reserve': 1.03,
      _default: 1.0,
    },
    aerodyne: {
      'smart-lpv': 1.05,
      'smart': 1.0,
      _default: 1.0,
    },
    paratec: {
      'speed-2000': 1.03,
      _default: 1.0,
    },
    _default_manufacturer: 1.0,
    _unknown_manufacturer: 0.95,
  },
  size: {
    small_threshold_sqft: 110,
    small_penalty: 0.90,
    large_threshold_sqft: 200,
    large_penalty: 0.85,
  },
};

export const MANUFACTURERS = {
  'performance-designs': {
    brand_key: 'performance-designs',
    models: {
      'optimum': { new_price_eur: 1705 },
      'reserve': { new_price_eur: 1496 },
    },
  },
  aerodyne: {
    brand_key: 'aerodyne',
    models: {
      'smart':     { new_price_eur: 1379 },
      'smart-lpv': { new_price_eur: 1527 },
    },
  },
  'icarus-world': {
    brand_key: 'icarus-world',
    models: {
      'icarus-reserve': { new_price_eur: 1496 },
      'nano-reserve':   { new_price_eur: 1666 },
    },
  },
  'precision-aerodynamics': {
    brand_key: 'precision-aerodynamics',
    models: {
      'raven': { new_price_eur: 1329 },
      'r-max': { new_price_eur: 1338 },
    },
  },
  firebird: {
    brand_key: 'firebird',
    models: {
      'rush':     { new_price_eur: 1392 },
      'rush-lpv': { new_price_eur: 870 },
    },
  },
  paratec: {
    brand_key: 'paratec',
    models: {
      'speed-2000': { new_price_eur: 2320 },
    },
  },
  skylark: {
    brand_key: 'skylark',
    models: {
      'standard-7': { new_price_eur: 1175 },
    },
  },
};
